module.exports = __webpack_public_path__ + "4afaa6164e1fab6258ad47d2b6cc511d.svg";